import TaskStatuses from "../../enums/taskStatuses";
import TaskActions from "../../enums/TaskActions";
import backgroundTasksEventsEmitter from "./events/backgroundTasksEventsEmitter";
import { type SCORMTask } from "./taskPool";

const tasks = {
  getFailed: (id: number, onClose: (id: number) => void): SCORMTask => {
    backgroundTasksEventsEmitter.updateHandlerOnce(TaskActions.close, id, onClose);

    return {
      id,
      status: TaskStatuses.failed,
      percent: 100,
      indeterminate: false,
      canClose: true,
      isUploading: false,
      isUploaded: false,
    } as SCORMTask;
  },

  getCanceled: (id: number, onClose: (id: number) => void): SCORMTask => {
    backgroundTasksEventsEmitter.updateHandlerOnce(TaskActions.close, id, onClose);

    return {
      id,
      status: TaskStatuses.canceled,
      percent: 100,
      indeterminate: false,
      canClose: true,
      isUploading: false,
      isUploaded: false,
    } as SCORMTask;
  },

  getUploadedSuccessfully: (id: number): SCORMTask =>
    ({
      id,
      status: TaskStatuses.successful,
      label: "Uploaded successfully!",
      percent: 100,
      indeterminate: false,
      isUploading: false,
      isUploaded: true,
      canCancel: false,
    }) as SCORMTask,

  getProcessing: (id: number): SCORMTask => {
    backgroundTasksEventsEmitter.unsubscribeAll(TaskActions.close, id);
    return {
      id,
      status: TaskStatuses.inProgress,
      label: "Processing...",
      errorLabel: "SCORM processing failed!",
      percent: 0,
      indeterminate: true,
      canClose: false,
    } as SCORMTask;
  },

  getReadyToPublish: (id: number, onClose: (taskId: number) => void): SCORMTask => {
    backgroundTasksEventsEmitter.updateHandlerOnce(TaskActions.close, id, onClose);
    return {
      id,
      status: TaskStatuses.successful,
      label: "Ready to publish!",
      percent: 100,
      indeterminate: false,
      canClose: true,
    } as SCORMTask;
  },

  getStarted: (id: string | number, title: string, onCancel?: () => void): SCORMTask =>
    ({
      id,
      status: TaskStatuses.inProgress,
      title,
      label: "Uploading...",
      isUploading: true,
      canCancel: !!onCancel,
      onCancel,
    }) as SCORMTask,
};

export default tasks;
